export enum ESupportMeasureReportCoverSheet {
  SIMPLE = 'simple',
  PLANT = 'plant',
}

export enum ESupportMeasureReportSignatory {
  TEACHER = 'teacher',
  PARENTS = 'parents',
  SCHOOL_ADMINISTRATION = 'schoolAdministration',
}

/** Query parameters of the report's print page, which the exporter opens per chunk of students. */
export enum ESupportMeasureReportQueryParam {
  ENTRY_ID = 'entryId',
  STUDENT_IDS = 'studentIds',
  COVER_SHEET = 'coverSheet',
  COMPETENCE_DEVELOPMENT = 'competenceDevelopment',
  COMPLETION_NOTE = 'completionNote',
  MATERIALS = 'materials',
  SIGNATORIES = 'signatories',
}
